import React, { useState, useEffect } from "react";
import { Col, Container, Modal, Row, Button, Dropdown, ButtonGroup } from 'react-bootstrap';
import { useSelector } from "react-redux";
import APICom from '../../../utils/helpers/APICom';


const SendNotificationActions = (props) => {

    const { GlobalASCSData}  = useSelector((store) => store.combinedata);
    const [showSendNotificationDialog, setSendNotificationDialog] = useState(false);
    const [displayNoDataAlert, setDisplayNoDataAlert] = useState(false);
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [selectedMessage, setSelectedMessage] = useState(null);
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [noDataAlert, setNoDataAlert] = useState({ alertTitle: '', alertMsg: '' });
    
    useEffect(() => {
        APICom.fetchData("", "TripActions/GetCannedMessages", "get", { "Content-Type": "application/json" }, null, null)
            .then(response => {
                setDropdownOptions(response.data.data);
            })
            .catch(error => console.error("Error fetching messages:", error));
    }, []);
    
    useEffect(() => {
        const rowData = props.GridRowData;
    
        if (!rowData || rowData.length !== 1) {
            // No trip selected or multiple trips selected
            setNoDataAlert({
                alertTitle: !rowData ? 'No trip selected' : 'Multiple trips selected',
                alertMsg: !rowData ? 'Please select a trip to send notification.' : 'Please select one trip to send notification.'
            });
            setPhone("");
            setMessage("");
            setDisplayNoDataAlert(true);
        } else {
            const gData = rowData[0];
            setPhone(gData["Phone"]);
            setSendNotificationDialog(true);
        }
    }, [props.GridRowData]);
    

    const handleSendNotificationActionSMS = async (e) => {
        try {
            const gData = props.GridRowData[0];
            const data = {
                "phone": phone,
                "Message": message,
                "notificationtype": "0",
                "agentID": "",
                "agentname": "",
                "urlparams":"",
                "ireqaffiliateid": gData["iSRATSPID"],
                "clientid": gData["ClientID"],
                "MarsID": gData["vMarsID"],


            };
            let inloadurl = "";
                if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                    const jsonArray = GlobalASCSData;
                    console.log("$$$$--ASCSSettingData | jsonArray--%%%", jsonArray);
                    const Marsinload = jsonArray.find(item => item.SubTitle === "InLoadAPI_URL");

                    if (Marsinload) {
                        inloadurl = Marsinload.value;
                    }
                }
            var response = await APICom.fetchData("full", `${inloadurl}/TripReservation/SendPushNotificationAndSMS`, "post", {}, data);
            setNoDataAlert({ ...noDataAlert, alertTitle: `SMS ${response.data ? response.data.SMSSent ? "Sent":"Failed" : "Failed"}`, alertMsg: `Response Message: ${response.data ? response.data.ResponseMessage : ""}` });
            setSendNotificationDialog(false);
            setDisplayNoDataAlert(true);
        }
        catch (err) { console.log(err); }
    }
    const handleSendNotificationActionNotification = async (e) => {
        try {
            const gData = props.GridRowData[0];
            const data = {
                "phone": phone,
                "Message": message,
                "notificationtype": "1",
                "agentID": "",
                "agentname": "",
                "urlparams":"",
                "ireqaffiliateid": gData["iSRATSPID"],
                "clientid": gData["ClientID"],
                "MarsID": gData["vMarsID"],


            };
            let inloadurl = "";
                if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                    const jsonArray = GlobalASCSData;
                    const Marsinload = jsonArray.find(item => item.SubTitle === "InLoadAPI_URL");

                    if (Marsinload) {
                        inloadurl = Marsinload.value;
                    }
                }
            var response = await APICom.fetchData("full", `${inloadurl}/TripReservation/SendPushNotificationAndSMS`, "post", {}, data);
            setNoDataAlert({ ...noDataAlert, alertTitle: `SMS ${response.data ? response.data.SMSSent ? "Sent":"Failed" : "Failed"}`, alertMsg: `Response Message: ${response.data ? response.data.ResponseMessage : ""}` });
            setSendNotificationDialog(false);
            setDisplayNoDataAlert(true);
        }
        catch (err) { console.log(err); }
    }
    const handleSendNotificationActionboth = async (e) => {
        try {
            const gData = props.GridRowData[0];
            const data = {
                "phone": phone,
                "Message": message,
                "notificationtype": "2",
                "agentID": "",
                "agentname": "",
                "urlparams":"",
                "ireqaffiliateid": gData["iSRATSPID"],
                "clientid": gData["ClientID"],
                "MarsID": gData["vMarsID"],

            };
            let inloadurl = "";
                if (GlobalASCSData !== null && GlobalASCSData !== undefined) {
                    const jsonArray = GlobalASCSData;
                    const Marsinload = jsonArray.find(item => item.SubTitle === "InLoadAPI_URL");

                    if (Marsinload) {
                        inloadurl = Marsinload.value;
                    }
                }
            var response = await APICom.fetchData("full", `${inloadurl}/TripReservation/SendPushNotificationAndSMS`, "post", {}, data);
            setNoDataAlert({ ...noDataAlert, alertTitle: `SMS ${response.data ? response.data.SMSSent ? "Sent":"Failed" : "Failed"}`, alertMsg: `Response Message: ${response.data ? response.data.ResponseMessage : ""}` });
            setSendNotificationDialog(false);
            setDisplayNoDataAlert(true);
        }
        catch (err) { console.log(err); }
    }

     // Helper function to format the phone number
     const formatPhoneNumber = (input) => {
        const numericInput = input.replace(/\D/g, '');
        const formattedNumber = numericInput.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        return formattedNumber;
    };

    // Handle changes in the phone number input
    const handlePhoneInputChange = (e) => {
        const inputValue = e.target.value;
        const formattedValue = formatPhoneNumber(inputValue);

        // Restrict the input to 12 characters
        if (formattedValue.length <= 12) {
            setPhone(formattedValue);
        }
    };

    const handleDropdownSelect = (selectedOption) => {
        setSelectedMessage(selectedOption); 
        setMessage(selectedOption.message); 
    }
    
    

    const handleSendNotificationDialogClose = () => {
        try {
            setSendNotificationDialog(false);
            UnMountSendNotificationComponent();
        } catch (err) {
            console.log(err);
        }
    }

    const handleAlertModalClose = () => {
        setDisplayNoDataAlert(false);
        UnMountSendNotificationComponent();
    }

    const UnMountSendNotificationComponent = () => {
        if (props.sendNotificationComponentLoaded) {
            props.setSendNotificationComponentLoad(false);
        }
    }
   
    return (
        <>
            {showSendNotificationDialog &&
                <Modal centered show={showSendNotificationDialog} onHide={handleSendNotificationDialogClose} animation={false}>
                    <Modal.Header className='activate_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                        <Modal.Title className='activate_dialog_title_color user-select-none'>Send Notification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="grid-example">
                        <Container>
                            <Row>
                                <Col className="user-select-none">
                                    Customer Phone:
                                </Col>
                                <Col>
                                    <input 
                                        value={phone}
                                        onChange={handlePhoneInputChange}
                                        maxLength="12" 
                                        />
                                </Col>
                            </Row>
                            <Row>
                                <Col className="user-select-none">
                                    Message:
                                </Col>
                                <Col>
                                    <div className="message-input-dropdown-wrapper">
                                        <Dropdown as={ButtonGroup}>
                                            <input
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                readOnly={selectedMessage !== null} // Make input readonly if a message is selected
                                            />

                                            <Dropdown.Toggle split size="sm" className="tripaction_btn_color" />
                                            <Dropdown.Menu>
                                                {dropdownOptions.length > 0 ? (
                                                    dropdownOptions.map((option) => (
                                                        <Dropdown.Item
                                                            key={option.id}
                                                            eventKey={option.message}
                                                            active={selectedMessage === option}
                                                            onClick={() => handleDropdownSelect(option)}
                                                    
                                                        >
                                                            {option.message}
                                                        </Dropdown.Item>
                                                    ))
                                                ) : (
                                                    <Dropdown.Item disabled>No messages available</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button className="tripaction_btn_color" onClick={handleSendNotificationActionSMS}>
                            Send SMS
                        </Button>
                        <Button className="tripaction_btn_color" onClick={handleSendNotificationActionNotification}>
                            Send Notification
                        </Button>
                        <Button className="tripaction_btn_color" onClick={handleSendNotificationActionboth}>
                            Both
                        </Button>
                        <Button variant="secondary" onClick={handleSendNotificationDialogClose}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>}
            {displayNoDataAlert && <Modal centered show={displayNoDataAlert} onHide={handleAlertModalClose} animation={false}>
                <Modal.Header className='noshow_dialog_header_bgcolor' style={{ height: "50px" }} closeButton>
                    <Modal.Title className='noshow_dialog_title_color'>{noDataAlert.alertTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body><b>{noDataAlert.alertMsg}</b></Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleAlertModalClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>}
        </>
    );
}

export default SendNotificationActions;
